// extracted by mini-css-extract-plugin
export default {"overlay":"cz-z","bodyOpen":"dz-z","content":"ez-z","header":"fz-z","close":"gz-z","closeNoHeading":"hz-z"};